import React from "react";
import { Message, toaster } from "rsuite";
import DeliveryAddressDto from "../interfaces/deliveryAddressDto";

const api = process.env.REACT_APP_API_URL ?? "http://localhost:8080";

export const getAllDeliveryAddresses = async (
  page: number,
  limit: number,
  query?: string,
  sortType?: string,
  sortColumn?: string
) => {
  return await fetch(
    `${api}/api/deliveryAddresses?page=${page - 1}&size=${limit}${
      query !== "" && query !== undefined ? `&query=${query}` : ""
    }${
      sortType !== undefined &&
      sortType !== null &&
      sortColumn !== undefined &&
      sortColumn !== null
        ? `&sort[${sortColumn}]=${sortType}`
        : ""
    }
    `,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
    }
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(`Something went wrong, ${JSON.stringify(res)}`);
      }
    })
    .catch((e) => {
      throw new Error(e);
    });
};

export const createDeliveryAddress = async (body: DeliveryAddressDto) => {
  return await fetch(`${api}/api/deliveryAddresses/createDeliveryAddress`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${localStorage.getItem("accessToken")}`,
    },
    body: JSON.stringify(body),
  })
    .then(async (res) => {
      if (res.ok) {
        const data = await res.json();
        toaster.push(
          <Message showIcon type='success' header='Erfolgreich'>
            Der Artikel {data.name} wurde erfolgreich gespeichert.
          </Message>
        );
      }
    })
    .catch((e) => {
      console.log(e);
      toaster.push(
        <Message showIcon type='error' header='Fehlgeschlagen'>
          Leider ist beim Speichern des Artikels etwas schiefgelaufen.
        </Message>
      );
      return;
    });
};

export const updateDeliveryAddress = async (
  id: number,
  body: DeliveryAddressDto
) => {
  try {
    const deliveryAddress = await fetch(`${api}/api/deliveryAddresses/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(body),
    });

    if (deliveryAddress.ok) {
      const data = await deliveryAddress.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der User {data.name} wurde erfolgreich gespeichert.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Speichern des Users etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};

export const deleteDeliveryAddress = async (id: number) => {
  try {
    const deleteDeliveryAddress = await fetch(
      `${api}/api/deliveryAddresses/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (deleteDeliveryAddress.ok) {
      const data = await deleteDeliveryAddress.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der DeliveryAddress {data.name} wurde erfolgreich gelöscht.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Löschen des DeliveryAddresses etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};
